import type { EMetricKey } from '~/types/metric';

import { usePageAnalyticDetailContext } from '~/modules/page-analytic/contexts/PageAnalyticDetailProvider';
import { ANALYTICS_METRIC_TOOLTIP, CardAnalyticEmpty } from '~/modules/analytics';
import { usePALineChartData } from '../../hooks/usePALineChartData';
import { PAChartSkeleton } from '../common/PAChartSkeleton';
import { PALineChartTooltip } from './PALineChartTooltip';
import { GChartProvider } from '~/presentation/charts';
import { LineChart } from '@shopify/polaris-viz';
import { BlockStack } from '@shopify/polaris';

export interface PALineChartProps {
  activeTab?: EMetricKey;
}

export const PALineChart: React.FC<PALineChartProps> = ({ activeTab }) => {
  const { lineChartData, formatValue, yAxisOptions } = usePALineChartData({ activeTab });
  const { isLoading, isEmptyMetricData } = usePageAnalyticDetailContext();

  if (isLoading) {
    return <PAChartSkeleton />;
  }

  if (isEmptyMetricData) {
    return <CardAnalyticEmpty />;
  }

  return (
    <BlockStack gap="400">
      <GChartProvider>
        <LineChart
          data={lineChartData}
          yAxisOptions={yAxisOptions}
          theme="Light"
          tooltipOptions={{
            titleFormatter: () =>
              `${ANALYTICS_METRIC_TOOLTIP[activeTab as EMetricKey]?.title ?? ''}`,
            keyFormatter: (value) => {
              return value as string;
            },
            renderTooltipContent(data) {
              return (
                <PALineChartTooltip data={data} formatValue={formatValue} metricKey={activeTab} />
              );
            },
          }}
          showLegend
        />
      </GChartProvider>
    </BlockStack>
  );
};
